import { Button, TextField } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { List } from 'components/reusable/list';
import { ReusableSelect as Select } from 'components/reusable/select';
import { useGlobalState } from 'store/reducers/reducer';
import { loadUsersBySearch } from 'store/sagas/sagas';
import { useDebounce } from 'utils/hooks';
import { humanDate } from 'utils/ui.utils';
import { pushFiltersSearchPath, rawParseQuery, transformQueryTypes } from 'utils/url';
const columns = [
    {
        xs: 1,
        name: 'ID',
        id: 'id'
    },
    {
        xs: 2,
        name: 'Account',
        id: 'sid'
    },
    {
        xs: 2,
        name: 'Email',
        id: 'email'
    },
    {
        xs: 1,
        name: 'First Name',
        id: 'firstName'
    },
    {
        xs: 2,
        name: 'Last Name',
        id: 'lastName'
    },
    {
        xs: 1,
        name: 'Email Verified',
        id: 'emailVerified'
    },
    {
        xs: 1,
        name: 'Disabled',
        id: 'isDisabled'
    },
    {
        xs: 2,
        name: 'Last Login',
        customRenderValue: (item) => {
            return item.loginAt ? humanDate(item.loginAt) : 'N/A';
        }
    }
];
const initialData = {
    firstName: '',
    lastName: '',
    email: '',
    page: 1,
    isAccountAdmin: '',
    isAdmin: '',
    isSupport: '',
    isReviewer: '',
    isDownloader: '',
    selfServe: '',
    isDisabled: '',
    pageSize: 50
};
const mapData = {
    firstName: 'string',
    lastName: 'string',
    email: 'string',
    page: 'number',
    isAccountAdmin: 'string',
    isAdmin: 'string',
    isSupport: 'string',
    isReviewer: 'string',
    isDownloader: 'string',
    selfServe: 'string',
    isDisabled: 'string',
    pageSize: 'number'
};
const filterOptions = {
    isDisabled: [
        { id: 'true', name: 'true' },
        { id: 'false', name: 'false' }
    ],
    isAccountAdmin: [
        { id: 'true', name: 'true' },
        { id: 'false', name: 'false' }
    ],
    isAdmin: [
        { id: 'true', name: 'true' },
        { id: 'false', name: 'false' }
    ],
    isSupport: [
        { id: 'true', name: 'true' },
        { id: 'false', name: 'false' }
    ],
    isReviewer: [
        { id: 'true', name: 'true' },
        { id: 'false', name: 'false' }
    ],
    isDownloader: [
        { id: 'true', name: 'true' },
        { id: 'false', name: 'false' }
    ],
    pageSize: [
        { id: 10, name: '10' },
        { id: 25, name: '25' },
        { id: 50, name: '50' },
        { id: 100, name: '100' },
        { id: 250, name: '250' },
        { id: 500, name: '500' }
    ]
};
export const UserManager = () => {
    const { asyncDispatch } = useGlobalState();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [users, setUsers] = useState([]);
    const [totalUsers, setTotalUsers] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isOpenFilters, setIsOpenFilters] = useState(true);
    const [filter, setFilter] = useState({
        ...initialData,
        ...transformQueryTypes(mapData, rawParseQuery())
    });
    const debouncedFilter = useDebounce(filter, 250);
    const updateFilter = (newFilter) => {
        setFilter({ ...initialData, ...newFilter });
    };
    const handleChangeFilters = useCallback((e) => {
        updateFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    }, [filter]);
    const handleGoToEditUser = useCallback((userId) => {
        navigate(`/admin/users/${userId}`);
    }, [navigate]);
    const handlePageChange = (_event, page) => {
        updateFilter({
            ...filter,
            page
        });
    };
    useEffect(() => {
        const { isInitial } = pushFiltersSearchPath({
            filter: debouncedFilter,
            initialData: initialData,
            mapData,
            path: pathname
        });
        if (!isOpenFilters && !isInitial) {
            setIsOpenFilters(true);
        }
        setLoading(true);
        asyncDispatch(loadUsersBySearch(debouncedFilter))
            .then((res) => {
            setUsers(res.users);
            setTotalUsers(res.total);
        }, console.error)
            .finally(() => {
            setLoading(false);
        });
    }, [debouncedFilter]);
    return (React.createElement("div", { className: "account-manager-container" },
        React.createElement("h1", null, "User Management"),
        React.createElement("div", { className: "filters__container" },
            React.createElement("div", { className: "filters", onClick: () => {
                    setIsOpenFilters(!isOpenFilters);
                } },
                React.createElement(FilterListIcon, { style: {
                        color: isOpenFilters ? '#4122af' : 'grey'
                    } }),
                React.createElement("span", null, "Filter")),
            isOpenFilters && (React.createElement("div", { className: "jobs__filters-container-container" },
                React.createElement("div", { className: "jobs-filters-container" },
                    React.createElement("div", { className: "grid-class-container" },
                        React.createElement("div", { className: "grid__col" },
                            React.createElement(Select, { className: "g-full-width u-margin-bottom-small", items: filterOptions.pageSize, label: "Size", name: "pageSize", onChange: handleChangeFilters, value: filter.pageSize })),
                        React.createElement("div", { className: "grid__col" },
                            React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", label: "Email", name: "email", onChange: handleChangeFilters, value: filter.email })),
                        React.createElement("div", { className: "grid__col" },
                            React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", label: "First Name", name: "firstName", onChange: handleChangeFilters, value: filter.firstName })),
                        React.createElement("div", { className: "grid__col" },
                            React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", label: "Last Name", name: "lastName", onChange: handleChangeFilters, value: filter.lastName })),
                        React.createElement("div", { className: "grid__col" },
                            React.createElement(Select, { className: "g-full-width u-margin-bottom-small", items: filterOptions.isDisabled, label: "Disabled", name: "isDisabled", onChange: handleChangeFilters, value: filter.isDisabled })),
                        React.createElement("div", { className: "grid__col" },
                            React.createElement(Select, { className: "g-full-width u-margin-bottom-small", items: filterOptions.isAccountAdmin, label: "Is Account Admin", name: "isAccountAdmin", onChange: handleChangeFilters, value: filter.isAccountAdmin })),
                        React.createElement("div", { className: "grid__col" },
                            React.createElement(Select, { className: "g-full-width u-margin-bottom-small", items: filterOptions.isAdmin, label: "Is System Admin", name: "isAdmin", onChange: handleChangeFilters, value: filter.isAdmin })),
                        React.createElement("div", { className: "grid__col" },
                            React.createElement(Select, { className: "g-full-width u-margin-bottom-small", items: filterOptions.isSupport, label: "Is Support Admin", name: "isSupport", onChange: handleChangeFilters, value: filter.isSupport })),
                        React.createElement("div", { className: "grid__col" },
                            React.createElement(Select, { className: "g-full-width u-margin-bottom-small", items: filterOptions.isReviewer, label: "Is Reviewer", name: "isReviewer", onChange: handleChangeFilters, value: filter.isReviewer })),
                        React.createElement("div", { className: "grid__col" },
                            React.createElement(Select, { className: "g-full-width u-margin-bottom-small", items: filterOptions.isDownloader, label: "Is Downloader", name: "isDownloader", onChange: handleChangeFilters, value: filter.isDownloader }))),
                    React.createElement("div", { className: "u-margin-bottom-large" },
                        React.createElement(Button, { color: "primary", onClick: () => {
                                setFilter({ ...initialData });
                            } }, "Clear")))))),
        React.createElement("div", { className: "account-grid" },
            React.createElement(List, { columns: columns, handlePageChange: handlePageChange, isClickable: () => true, items: users, label: "Users", loading: loading, onClick: (item) => {
                    handleGoToEditUser(item.id);
                }, page: filter.page, total: totalUsers, totalPages: Math.ceil(totalUsers / filter.pageSize) }))));
};
